import { View, ViewOpts, animate } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { magicLampsAnim } from './MagicLampsAnim';

interface MagicLampsInfoBlockOpts extends ViewOpts {
  icon: View;
  i18nKey: string;
}

export class MagicLampsInfoBlock extends View {
  private container: View;
  private icon: View;
  private text: LangBitmapFontTextView;

  constructor(opts: MagicLampsInfoBlockOpts) {
    super({ ...opts });

    this.container = new View({
      superview: this,
    });

    this.icon = opts.icon;
    this.icon.updateOpts({ superview: this.container });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: 80,
      y: -80,
      align: 'left',
      verticalAlign: 'center',
      anchorY: 0.5,
      size: 22,
      font: 'Title',
      width: 450,
      height: 150,
      wordWrap: true,
    });
    this.text.localeText = () => i18n(opts.i18nKey);
  }

  public async showAnimated() {
    this.show();
    this.updateOpts({ opacity: 1 });
    this.text.updateOpts({ opacity: 0, offsetY: 50 });
    this.container.updateOpts({ scale: 0 });
    magicLampsAnim(this.container, { scale: 1 }, 300, animate.easeOutBack);
    await magicLampsAnim(
      this.text,
      { opacity: 1, offsetY: 0 },
      300,
      animate.easeOutExpo,
    );
  }

  public async hideAnimated() {
    await animate(this).now({ opacity: 0 }, 200).toPromise();
    this.hide();
  }
}
